// @flow
import PasswordValidator from 'password-validator';

// eslint-disable-next-line import/prefer-default-export
export const validatePassword = (password: string): boolean => {
  const schema = new PasswordValidator();

  schema
    .is()
    .min(8)
    // .has()
    .lowercase()
    .has();
  // .digits();

  return schema.validate(password);
};
